export const ON_LOADING = "ON_LOADING"
export const ON_LOADED = "ON_LOADED"
